import React, { forwardRef, memo } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Icon,
  IconButton,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import TldrUpgradeSubscriptionModal from "../../common/modals/TldrUpgradeSubscriptionModal";

const countStyles = {
  position: "absolute",
  top: "0",
  right: "0",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "0 0.4em",
  background: "gray.600",
  color: "whiteAlpha.900",
  border: "1px solid",
  borderColor: "whiteAlpha.300",
  borderRadius: "full",
  fontSize: "0.6em",
  lineHeight: "1em",
  height: "1.8em",
  minWidth: "1.8em",
};

const AdvancedMessageToolbarButton = forwardRef(
  (
    {
      tooltipLabel,
      icon,
      isDisabled,
      isActive,
      count,
      off,
      upgradeRequired,
      onClick,
      ...rest
    },
    ref
  ) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
      <>
        <Tooltip
          label={tooltipLabel}
          hasArrow
          placement="top"
          shouldWrapChildren={isDisabled}
          isDisabled={!tooltipLabel}
        >
          <IconButton
            ref={ref}
            size="sm"
            variant="ghost"
            isDisabled={isDisabled}
            onClick={upgradeRequired ? onOpen : onClick}
            {...rest}
          >
            <>
              <Icon
                as={icon}
                fontSize="md"
                color={isActive ? "brand.primary" : null}
              />
              {count ? <Box sx={countStyles}>{count}</Box> : null}
            </>
          </IconButton>
        </Tooltip>
        {isOpen ? <TldrUpgradeSubscriptionModal show onHide={onClose} /> : null}
      </>
    );
  }
);

AdvancedMessageToolbarButton.propTypes = {
  tooltipLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.func,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func])
    .isRequired,
  isDisabled: PropTypes.bool,
  isActive: PropTypes.bool,
  upgradeRequired: PropTypes.bool,
  count: PropTypes.number,
  onClick: PropTypes.func,
};

AdvancedMessageToolbarButton.defaultProps = {
  tooltipLabel: undefined,
  isDisabled: undefined,
  isActive: undefined,
  upgradeRequired: undefined,
  count: undefined,
  onClick: undefined,
};

export default memo(AdvancedMessageToolbarButton);
